<template>
  <div class="jyohou">
    <div class="info-msg">
      <div class="info-name"><u>東港金属・本社工場</u></div>
      <el-form :model="form" :rules="rules2" ref="form" label-position="left" label-width="0" class="card-box-info">
        <el-row>
          <el-col :span="24"><div class="titleInfo"><span>{{systemName}}</span></div></el-col>
        </el-row>
        <el-row class="jyohou-row">
          <el-col :span="8" class="jyohou-label-nomal">
            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div style="width: 140px">御担当名</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohou-input">
            <el-row>
              <el-col :span="12">
                <div class="jyohou-namae">姓</div>
              </el-col>
              <el-col :span="12">
                <div class="jyohou-namae">名</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="namesei">
                  <el-input type="text" style="width: 150px;margin-left: 30px" v-model="form.namesei" value = 'this.form.namesei'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="namemei">
                  <el-input type="text" style="width: 150px;margin-left: 30px" v-model="form.namemei"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-col>

        </el-row>

        <el-row>
          <el-col :span="8"class="jyohou-label-nomal">
            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="24">
                <div style="width: 180px">フリガナ</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohou-mail-input">
            <el-row>
              <el-col :span="12">
                <div class="jyohou-namae">姓（カタカナ）</div>
              </el-col>
              <el-col :span="12">
                <div class="jyohou-namae">名（カタカナ）</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="kanasei">
                  <el-input type="text" style="width: 150px;margin-left: 30px" v-model="form.kanasei"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="kanamei">
                  <el-input type="text" style="width: 150px;margin-left: 30px" v-model="form.kanamei"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>

        </el-row>
        <el-row style="margin-top: 0.2em;margin-bottom: 0.2em">
          <el-col :span="8"class="jyohou-label">
            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>
            <el-row style="width: 150px">
              <el-col :span="24">
                <div>メールアドレス</div>
              </el-col>
            </el-row>

            <el-row style="margin-top: 5em">
              <el-col :span="24">
                <div style="width: 180px;margin-top: 1em">追加メールアドレス１</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohou-input-mail">
            <el-row>
              <el-col :span="24" >
                <el-form-item prop="mail1" style='height: 60px'>
                  <el-input type="text" style="margin-left: 20px;width: 80%" v-model="form.mail1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" >
                <div style="margin-left: 10px">再入力</div>
              </el-col>
              <el-col :span="20" >
                <el-form-item prop="remail1" style='height: 60px'>
                  <el-input type="text" style="width: 90%" v-model="form.remail1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" >
                <el-form-item prop="mail2" style='height: 60px'>
                  <el-input type="text" style="margin-left: 20px;width: 80%" v-model="form.mail2"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" >
                <div style="margin-left: 10px">再入力</div>
              </el-col>
              <el-col :span="20" >
                <el-form-item prop="remail2" style='height: 60px'>
                  <el-input type="text" style="width: 90%" v-model="form.remail2"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-col>

        </el-row>

        <el-row class="jyohou-row">
          <el-col :span="8" class="jyohou-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">会社名</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohou-input-samll">
            <div style="margin: 20px">{{form.companyName}}</div>
          </el-col>

        </el-row>

        <el-row class="jyohou-row">
          <el-col :span="8" class="jyohou-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">運送会社名</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohou-input-samll">
            <el-form-item prop="truckCompName" >
              <el-input type="text" class="jyohou-el-input-samll" v-model="form.truckCompName" ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row class="jyohou-row">
          <el-col :span="8" class="jyohou-label-small">
            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div style="width: 140px">電話番号</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="16" class="jyohou-input-samll" style="margin-top: 5px">
            <el-row >
              <el-col :span="4">
                <el-form-item prop="telNumber1" >
                  <el-input type="text" style="width: 80px;margin-left: 20px" id = 'telNumber1' v-model="form.telNumber1" :maxlength = 4></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="telNumber2" >
                <el-input type="text" style="width: 80px;margin-left: 46px" id = 'telNumber2' v-model="form.telNumber2" :maxlength = 4></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="telNumber3" >
                <el-input type="text" style="width: 80px;margin-left: 40px" id = 'telNumber3' v-model="form.telNumber3" :maxlength= 4></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
          </el-col>

        </el-row>
        <el-row class="jyohou-row">
          <el-col :span="8" class="jyohou-label-small">
            <el-row >
              <el-col :span="24">
                <div style="width: 140px">夜間連絡先</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="16" class="jyohou-input-samll" style="margin-top: 5px">
            <el-row >
              <el-col :span="4">
                <el-form-item prop="truckTel1" >
                <el-input type="text" style="width: 80px;margin-left: 20px" id = 'truckTel1' v-model="form.truckTel1" :maxlength= 4></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="truckTel2" >
                <el-input type="text" style="width: 80px;margin-left: 46px"  id = 'truckTel2' v-model="form.truckTel2" :maxlength= 4></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="truckTel3" >
                <el-input type="text" style="width: 80px;margin-left: 40px"  id = 'truckTel3' v-model="form.truckTel3" :maxlength= 4></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="text-align: center;margin-top: 1em">
          <el-col :span="24">
            <div>ご記入された内容がよろしければ</div>
          </el-col>
        </el-row>

        <el-row style="text-align: center">
          <el-col :span="24">
            <div style="">下の確認ボタンを押して次へお進みください</div>
          </el-col>
        </el-row>

        <el-row style="text-align: center">
          <el-col :span="24">
            <el-form-item >
              <el-button type="danger" class="kakuninn-btn" @click.native.prevent="handleSubmit2('form')">確　認</el-button>
              <el-button type="danger" @click.native.prevent="clean()"><i class="el-icon-caret-right"style="color: white;"></i>終　了</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'
  import { isName, isKana, isEmail, isCompName, isTel, isTel2 } from '../../assets/js/check'

  export default {
    data() {
      var checkNamesei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('御担当名「姓」を入力してください。'))
        } else if (!isName(value)) {
          callback(new Error('御担当名「姓」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkNamemei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('御担当名「名」を入力してください。'))
        } else if (!isName(value)) {
          callback(new Error('御担当名「名」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkKanasei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('フリガナ「姓」を入力してください。'))
        } else if (!isKana(value)) {
          callback(new Error('フリガナ「姓」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkKanamei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('フリガナ「名」を入力してください。'))
        } else if (!isKana(value)) {
          callback(new Error('フリガナ「名」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkMail1 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('メールアドレスを入力してください。'))
        } else if (!isEmail(value)) {
          callback(new Error('メールアドレスを正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkRemail1 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('メールアドレス「再入力」を入力してください。'))
        } else if (this.form.mail1 !== value) {
          callback(new Error('2回の入力が一致しない！'))
        } else {
          callback()
        }
      }
      var checkmail2 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback()
        } else {
          if (!isEmail(value)) {
            callback(new Error('追加メールアドレス１を正しく入力してください。'))
          } else {
            callback()
          }
        }
      }
      var checkremail2 = (rule, value, callback) => {
        if (this.form.mail2 !== null && this.form.mail2 !== '') {
          if (value === null || value === '') {
            callback(new Error('追加メールアドレス１「再入力」を入力してください。'))
          } else if (this.form.mail2 !== value) {
            callback(new Error('2回の入力が一致しない！'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      var checktruckCompName = (rule, value, callback) => {
        if (!isCompName(value)) {
          callback(new Error('運送会社名を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var telNumber1 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('電話番号を入力してください。'))
        } else if (!isTel(value)) {
          callback(new Error('電話番号を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var telNumber2 = (rule, value, callback) => {
        if (!isTel2(value)) {
          callback(new Error('電話番号を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var telNumber3 = (rule, value, callback) => {
        if (this.form.telNumber2 !== null || this.form.telNumber2 !== '') {
          if (value === null || value === '') {
            callback(new Error('電話番号を入力してください。'))
          } else if (!isTel2(value)) {
            callback(new Error('電話番号を正しく入力してください。'))
          } else {
            callback()
          }
        } else {
          if (!isTel2(value)) {
            callback(new Error('電話番号を正しく入力してください。'))
          } else {
            callback()
          }
        }
      }
      var checktelNumber1 = (rule, value, callback) => {
        if (value !== null || value !== '') {
          if (!isTel(value)) {
            callback(new Error('夜間連絡先を正しく入力してください。'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      var checktelNumber2 = (rule, value, callback) => {
        if (!isTel2(value)) {
          callback(new Error('夜間連絡先を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checktelNumber3 = (rule, value, callback) => {
        if (this.form.truckTel2 !== null || this.form.truckTel2 !== '') {
          if (value !== null || value !== '') {
            if (!isTel2(value)) {
              callback(new Error('夜間連絡先を正しく入力してください。'))
            } else {
              callback()
            }
          } else {
            if (!isTel2(value)) {
              callback(new Error('夜間連絡先を正しく入力してください。'))
            } else {
              callback()
            }
          }
        }
      }
      return {
        title: '',
        systemName: '夜間産廃搬入情報入力',
        errorMsg: '',
        companyName: '',
        form: {
          namesei: '',
          clientId: '',
          namemei: '',
          kanasei: '',
          kanamei: '',
          mail1: '',
          remail1: '',
          mail2: '',
          remail2: '',
          companyName: '',
          truckCompName: '',
          telNumber1: '',
          telNumber2: '',
          telNumber3: '',
          truckTel1: '',
          truckTel2: '',
          truckTel3: ''
        },
        rules2: {
          namesei: [
            { required: true, validator: checkNamesei, trigger: 'blur' }
          ],
          namemei: [
            { required: true, validator: checkNamemei, trigger: 'blur' }
          ],
          kanasei: [
            { required: true, validator: checkKanasei, trigger: 'blur' }
          ],
          kanamei: [
            { required: true, validator: checkKanamei, trigger: 'blur' }
          ],
          mail1: [
            { required: true, validator: checkMail1, trigger: 'blur' }
          ],
          remail1: [
            { required: true, validator: checkRemail1, trigger: 'blur' }
          ],
          mail2: [
            { validator: checkmail2, trigger: 'blur' }
          ],
          remail2: [
            { validator: checkremail2, trigger: 'blur' }
          ],
          truckCompName: [
            { validator: checktruckCompName, trigger: 'blur' }
          ],
          telNumber1: [
            { required: true, validator: telNumber1, trigger: 'blur' }
          ],
          telNumber2: [
            { required: true, validator: telNumber2, trigger: 'blur' }
          ],
          telNumber3: [
            { required: true, validator: telNumber3, trigger: 'blur' }
          ],
          truckTel1: [
            { validator: checktelNumber1, trigger: 'blur' }
          ],
          truckTel2: [
            { validator: checktelNumber2, trigger: 'blur' }
          ],
          truckTel3: [
            { validator: checktelNumber3, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      clean() {
        window.localStorage.setItem('userId', '')
        this.resetCommonData('/customer/login')
        _g.toastMsg('warning', 'ログアウトしました！')
      },
      handleSubmit2(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            var telNumber1 = ''
            var telNumber2 = ''
            var telNumber3 = ''
            var truckTel1 = ''
            var truckTel2 = ''
            var truckTel3 = ''
            if ((this.form.telNumber1.length + this.form.telNumber2.length + this.form.telNumber3.length) > 11 ||
              (this.form.telNumber1.length + this.form.telNumber2.length + this.form.telNumber3.length) < 10) {
              telNumber1 = document.getElementById('telNumber1')
              telNumber2 = document.getElementById('telNumber2')
              telNumber3 = document.getElementById('telNumber3')
              telNumber1.style.border = '1px solid #f56c6c'
              telNumber2.style.border = '1px solid #f56c6c'
              telNumber3.style.border = '1px solid #f56c6c'
              _g.toastMsg('error', '電話番号を正しく入力してください。')
              return
            } else {
              telNumber1 = document.getElementById('telNumber1')
              telNumber2 = document.getElementById('telNumber2')
              telNumber3 = document.getElementById('telNumber3')
              telNumber1.style.border = ''
              telNumber2.style.border = ''
              telNumber3.style.border = ''
            }
            if ((this.form.truckTel1.length + this.form.truckTel2.length + this.form.truckTel3.length) !== 0) {
              if ((this.form.truckTel1.length + this.form.truckTel2.length + this.form.truckTel3.length) > 11 ||
                (this.form.truckTel1.length + this.form.truckTel2.length + this.form.truckTel3.length) < 10) {
                truckTel1 = document.getElementById('truckTel1')
                truckTel2 = document.getElementById('truckTel2')
                truckTel3 = document.getElementById('truckTel3')
                truckTel1.style.border = '1px solid #f56c6c'
                truckTel2.style.border = '1px solid #f56c6c'
                truckTel3.style.border = '1px solid #f56c6c'
                _g.toastMsg('error', '夜間連絡先を正しく入力してください。')
                return
              } else {
                truckTel1 = document.getElementById('truckTel1')
                truckTel2 = document.getElementById('truckTel2')
                truckTel3 = document.getElementById('truckTel3')
                truckTel1.style.border = ''
                truckTel2.style.border = ''
                truckTel3.style.border = ''
              }
            }
            let data = {}
            data.clientId = this.form.clientId
            data.namesei = this.form.namesei
            data.namemei = this.form.namemei
            data.kanasei = this.form.kanasei
            data.kanamei = this.form.kanamei
            data.mail1 = this.form.mail1
            data.remail1 = this.form.remail1
            data.mail2 = this.form.mail2
            data.remail2 = this.form.remail2
            data.companyName = this.form.companyName
            data.truckCompName = this.form.truckCompName
            data.telNumber1 = this.form.telNumber1
            data.telNumber2 = this.form.telNumber2
            data.telNumber3 = this.form.telNumber3
            data.truckTel1 = this.form.truckTel1
            data.truckTel2 = this.form.truckTel2
            data.truckTel3 = this.form.truckTel3
            var truckTelSiban = this.form.truckTel1.toString()
            var truckTelKaiban = this.form.truckTel2.toString()
            var truckTelKyoKuBan = this.form.truckTel3.toString()
            this.apiPost('customer/InformationInput/save', data).then((res) => {
              if (res.code != 200) {
                this.handleError(res)
              } else {
                this.$router.push({ path: '/customer/informationInputDetail', query: { clientId: this.form.clientId, truckCompName: this.form.truckCompName, truckTelSiban: truckTelSiban, truckTelKaiban: truckTelKaiban, truckTelKyoKuBan: truckTelKyoKuBan }})
              }
            })
          } else {
            return false
          }
        })
      }
    },
    created() {
      let data = {}
      data.clientId = window.localStorage.getItem('userId')
      data.reservedId = ''
      this.apiPost('customer/InformationInput/index', data).then((res) => {
        this.handelResponse(res, (data) => {
          this.form.clientId = data.client_id
          this.form.namesei = data.contact_name_sei
          this.form.namemei = data.contact_name_mei
          this.form.kanasei = data.contact_kana_sei
          this.form.kanamei = data.contact_kana_mei
          this.form.mail1 = data.mail_address
          this.form.remail1 = data.mail_address
          this.form.mail2 = data.mail_address_1
          this.form.remail2 = data.mail_address_1
          this.form.companyName = data.company_name
          this.form.truckCompName = data.truck_comp_name
          this.form.telNumber1 = data.companytel_siban
          this.form.telNumber2 = data.companytel_kaiban
          this.form.telNumber3 = data.companytel_kyokuban
        })
      })
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          this.handleSubmit2('form')
        }
      })
    },
    mixins: [http]
  }
</script>

<style>
  @import url("../../assets/css/common.css");

  .jyohou-namae{
    width: 140px;
    margin: 10px;
  }
  .jyohou-namae-input{

  }
  .jyohou-el-input-samll{
    margin: 10px 20px 0px 20px
  }
  .jyohou-el-input{
    margin: 30px 20px 0px 20px
  }
  .jyohou-row{
    margin-bottom: 0.1em;
  }
  .jyohou-input-mail{
    height: 240px;
    background-color:#F5F7F7;
  }
  .jyohou-input{
    height: 110px;
    background-color:#F5F7F7;
  }
  jyohou-mail-input{
    height: 100px;
    background-color:#F5F7F7;
  }
  .jyohou-input-samll{
    height: 40px;
    background-color:#F5F7F7;
  }

  .jyohou-label-nomal{
    height: 110px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }

  .jyohou-label{
    height: 240px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .jyohou-label-small{
    height: 60px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .kakuninn-btn{
    margin-top: 1.5em;
    margin-bottom: 1em;
    width: 150px;
  }

  .verify-pos {
    position: absolute;
    right: 100px;
    top: 0px;
  }
  .card-box-info {
    padding: 1em;
  }
  .info-msg {
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 1em auto;
    width: 44em;
    border: 0.1em solid #8492A6;
  }
  .titleInfo {
    color: #505458;
    font-weight: bold;
    font-size: 1.17em;
    padding: 0em 0em 1em 0.5em;
  }
  .info-name{
    text-align: right;
    padding: 0.5em;
    font-weight: bold;
    font-size: 1.3em;
  }
</style>
<style>
  .jyohou .el-radio{
    margin-top: 0em;
    font-size: 18px;
  }
  .jyohou .el-input{
    width: 350px;
  }
  .jyohou .el-form-item__error{
    left: 8%;
  }
  .jyohou .el-input__inner{
    height: 30px;
  }

  .jyohou .el-form-item{
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/informationInput.vue